import { React } from "react";
import DashboardLogo from "./DashboardLogo";
import Burger from "./Burger/Burger";
import "./MenuBar.css";

const MenuBar = (props) => {
  return (
    <div className="menu-bar">
      <DashboardLogo />
      <Burger
        handleMenuChange={props.handleMenuChange}
        menuIsOpen={props.menuIsOpen}
        windowWidth={props.windowWidth}
      />
    </div>
  );
};

export default MenuBar;
